import { useEffect, useState, type ReactNode, type ReactElement } from 'react';
import { Sidebar } from './Sidebar.js';
import { Topbar } from './Topbar.js';
import { CmdK } from './CmdK.js';
import type { MeUser } from '../../api/admin.js';

interface AppShellProps {
  user: MeUser;
  children: ReactNode;
}

export function AppShell({ user, children }: AppShellProps): ReactElement {
  const [cmdkOpen, setCmdkOpen] = useState(false);

  useEffect(() => {
    function onKey(e: KeyboardEvent): void {
      const meta = e.metaKey || e.ctrlKey;
      if (meta && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setCmdkOpen((v) => !v);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="app">
      <Sidebar />
      <Topbar user={user} onOpenCmdK={() => setCmdkOpen(true)} />
      <main className="main">{children}</main>
      <CmdK open={cmdkOpen} onClose={() => setCmdkOpen(false)} />
    </div>
  );
}
